// Leitura dos horarios da semana pro cabecalho.
// Mesmas regras do modal "Informacoes da Loja", inclusive o segundo periodo
// (almoco/jantar) e o "24 horas" da v1.5.440 — se divergirem, o cliente ve um
// horario no cabecalho e outro no modal.

export const DIAS = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];

/** Indice do dia de hoje na convencao do businessHours (0 = Segunda). */
export function hojeIdx(agora = new Date()) {
  const i = agora.getDay() - 1;
  return i < 0 ? 6 : i;
}

/** { aberto, texto } do dia. Texto pronto pra exibir. */
export function horarioDoDia(businessHours, idx) {
  const h = (businessHours || []).find((x) => x.day_of_week === idx);
  if (!h || !h.is_open) return { aberto: false, texto: "Fechado" };
  if (h.is_24h) return { aberto: true, texto: "24 horas" };
  const primeiro = `${h.opening_time || ""} às ${h.closing_time || ""}`;
  return {
    aberto: true,
    texto: [
      primeiro,
      h.has_second_period ? `${h.opening_time_2 || ""} às ${h.closing_time_2 || ""}` : null,
      h.has_third_period ? `${h.opening_time_3 || ""} às ${h.closing_time_3 || ""}` : null,
    ]
      .filter(Boolean)
      .join(" · "),
  };
}

/** Minutos desde a meia-noite de "HH:MM"; null se nao parsear. */
function paraMinutos(hhmm) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || "").trim());
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
}

/**
 * Proxima abertura a partir de agora: { quando, hora } ou null.
 *
 * Existe porque o `nextOpenTime` que a pagina calcula so enxerga o dia de HOJE
 * — depois do ultimo fechamento ele vem nulo, e o cliente via so "Fechado", sem
 * saber quando voltar. Aqui a varredura segue pelos proximos 7 dias.
 *
 * `quando` ja vem pronto pra exibir: "hoje", "amanhã" ou o nome do dia.
 */
export function proximaAbertura(businessHours, agora = new Date()) {
  if (!(businessHours || []).length) return null;
  const minutosAgora = agora.getHours() * 60 + agora.getMinutes();
  const base = hojeIdx(agora);

  for (let salto = 0; salto < 7; salto += 1) {
    const idx = (base + salto) % 7;
    const h = (businessHours || []).find((x) => x.day_of_week === idx);
    if (!h || !h.is_open) continue;
    if (h.is_24h) {
      // Dia 24h: se e' hoje a loja ja estaria aberta (nao cairia aqui); nos
      // proximos dias, a virada da meia-noite e' a abertura.
      if (salto > 0) return { quando: rotuloDia(salto, idx), hora: "00:00" };
      continue;
    }

    // Os dois periodos do dia, em ordem. Hoje, so vale o que ainda nao passou.
    const candidatos = [
      h.opening_time,
      h.has_second_period ? h.opening_time_2 : null,
      h.has_third_period ? h.opening_time_3 : null,
    ]
      .map(paraMinutos)
      .filter((m) => m != null)
      .sort((a, b) => a - b);

    for (const inicio of candidatos) {
      if (salto === 0 && inicio <= minutosAgora) continue;
      const hh = String(Math.floor(inicio / 60)).padStart(2, "0");
      const mm = String(inicio % 60).padStart(2, "0");
      return { quando: rotuloDia(salto, idx), hora: `${hh}:${mm}` };
    }
  }
  return null;
}

function rotuloDia(salto, idx) {
  if (salto === 0) return "hoje";
  if (salto === 1) return "amanhã";
  return DIAS[idx].toLowerCase();
}
